import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash-es';

import Icon from './icon';

import './ContactCard.scss';

const ExtraBlock = ({ extras /* , fill */ }) => {
  if (Array.isArray(extras) && extras.length > 0) {
    const items = extras.map((extra, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <div className="para link" key={`block-extra-${idx}`}>
        <a href={get(extra, 'url')}>{get(extra, 'label')}</a>
      </div>
    ));
    return <div className="extras">{items}</div>;
  }
  return [];
};
ExtraBlock.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  extras: PropTypes.array.isRequired,
  fill: PropTypes.string.isRequired,
};
class ContactCard extends React.PureComponent {
  render() {
    const { title, emailContact, phoneContact, scheduleContact, icon, fill, extras } = this.props;

    return (
      <div className="dlpk contact block">
        <div className="core">
          <div className="icon">
            <Icon name={icon} width={100} fill={fill} />
          </div>
          <div className="core">
            <div className="title" style={{ color: fill }}>
              {title}
            </div>
            <div className="para top">
              <a href={`mailto:${emailContact}`} style={{ color: fill }}>
                {emailContact}
              </a>
            </div>
            <div className="para bottom phone" style={{ color: fill, borderColor: fill }}>
              {phoneContact}
            </div>
            <div className="para top" style={{ color: fill }}>
              {scheduleContact}
            </div>
          </div>
        </div>
        <ExtraBlock extras={extras} fill={fill} />
      </div>
    );
  }
}

ContactCard.propTypes = {
  title: PropTypes.string,
  emailContact: PropTypes.string,
  phoneContact: PropTypes.string,
  scheduleContact: PropTypes.string,
  icon: PropTypes.string,
  fill: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  extras: PropTypes.array,
};

ContactCard.defaultProps = {
  title: "Besoin d'aide ?",
  emailContact: 'service.partenaire@nevidis.fr',
  phoneContact: '01 87 66 84 15',
  scheduleContact: '',
  icon: 'contact',
  fill: '#0d1d70',
  extras: [],
};

export default ContactCard;
